import { Control, FieldValues, Path, useController } from 'react-hook-form';
import styled from 'styled-components';

import { Input, Label } from '@/components/Forms';
import ValidationMessage from '@/components/Forms/ValidationMessage';

const InputWrap = styled.div`
  display: flex;
  gap: 8px;
  ${Input} {
    flex: 1;
    margin-right: 8px;
    border: 0;
    background: #efefef;
    padding: 3px;
  }
`;

const ResetButton = styled.button`
  width: 46px;
  height: 46px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  color: ${({ theme }) => theme.colors.gray};
  transition: 0.2s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    border-color: ${({ theme }) => theme.colors.gray};
  }
`;

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  defaultValue: string;
  label: string;
}

const ColorField = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  label,
}: Props<T>) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController<T>({
    name,
    control,
  });

  const onReset = () => onChange(defaultValue);

  return (
    <div>
      <Label>{label}</Label>
      <InputWrap>
        <Input type="color" value={value} onChange={onChange} />
        <ResetButton onClick={onReset}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.23657 7.79004H2.48657V4.04004"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.13822 14.8614C6.09971 15.8229 7.32472 16.4776 8.65834 16.7429C9.99196 17.0082 11.3743 16.872 12.6305 16.3517C13.8868 15.8313 14.9605 14.9501 15.7159 13.8196C16.4714 12.689 16.8746 11.3598 16.8746 10C16.8746 8.64026 16.4714 7.31105 15.7159 6.18046C14.9605 5.04987 13.8868 4.16868 12.6305 3.64833C11.3743 3.12798 9.99196 2.99183 8.65834 3.2571C7.32472 3.52238 6.09971 4.17716 5.13822 5.13864L2.48657 7.79029"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </ResetButton>
      </InputWrap>
      {!!error && <ValidationMessage>{error.message}</ValidationMessage>}
    </div>
  );
};

export default ColorField;
